import "./NoticeCard.css"

function NoticeCard() {
  return (
    <div className="containerCard">
      <div className="BannerNotice">
        <img src="../../../assets/noticia.jpeg" alt="Capa da Notícia" />
      </div>
      <div className="titleNoticia">
        <h3>Cia Canoinhas doa
          computadores para o Hospital Santa Cruz</h3>
      </div>
      <a href="/Notice">Confira</a>
    </div>
  )
}

export default NoticeCard;